__turbopack_context__.v({
  "count": "styles-module-scss-module__f17HXW__count",
  "enter": "styles-module-scss-module__f17HXW__enter",
  "exit": "styles-module-scss-module__f17HXW__exit",
  "fade-in": "styles-module-scss-module__f17HXW__fade-in",
  "fade-out": "styles-module-scss-module__f17HXW__fade-out",
  "fade-out-80": "styles-module-scss-module__f17HXW__fade-out-80",
  "grid": "styles-module-scss-module__f17HXW__grid",
  "orderBadge": "styles-module-scss-module__f17HXW__orderBadge",
  "slide-in-from-bottom": "styles-module-scss-module__f17HXW__slide-in-from-bottom",
  "slide-in-from-left": "styles-module-scss-module__f17HXW__slide-in-from-left",
  "slide-in-from-right": "styles-module-scss-module__f17HXW__slide-in-from-right",
  "slide-in-from-top": "styles-module-scss-module__f17HXW__slide-in-from-top",
  "slide-out-to-bottom": "styles-module-scss-module__f17HXW__slide-out-to-bottom",
  "slide-out-to-left": "styles-module-scss-module__f17HXW__slide-out-to-left",
  "slide-out-to-right": "styles-module-scss-module__f17HXW__slide-out-to-right",
  "slide-out-to-top": "styles-module-scss-module__f17HXW__slide-out-to-top",
  "zoom-in": "styles-module-scss-module__f17HXW__zoom-in",
  "zoom-out": "styles-module-scss-module__f17HXW__zoom-out",
});
